module.exports = __webpack_public_path__ + "static/media/20ECE31.3e01a589.jpg";